import { AppActions } from "../../action";
import { SET_VOTE_DETAIL, SET_BALLOT_DESIGNATION, SET_EXPORT_VOTER_LIST, VOTE_DETAIL, SET_BALLOT_ITEM_INFORMATION, SET_NEGATIVE_RULING_RATIONALE } from "../../action-type";

const initialState = {
  ballotDesigantionData: [],
  voteDetail: null,
  exportVoterList: false,
  ballotItemInformationDetail: null,
  negativeRulingRationaleDetail: null,
};

type actionsType = AppActions;

const ballotReducer = (state: any = initialState, action: actionsType): any => {
  switch (action.type) {
    case SET_BALLOT_DESIGNATION:
      return {
        ...state,
        ballotDesignationData: action.data || "",
      };
    case SET_VOTE_DETAIL:
        return {
          ...state,
          voteDetail: action.data
        };
    case VOTE_DETAIL:
        return {
          ...state,
          savedVoteData: action.data
        }
    case SET_EXPORT_VOTER_LIST:
        return {
          ...state,
          exportVoterList: action.data
      };
    case SET_BALLOT_ITEM_INFORMATION:
      return {
        ...state,
        ballotItemInformationDetail: action.data
      };
    case SET_NEGATIVE_RULING_RATIONALE:
      return {
        ...state,
        negativeRulingRationaleDetail: action.data
      };
    default:
      return state;
  }
};

export default ballotReducer;